import React from 'react';
import { Alert } from 'react-bootstrap-5';

export default function ErrorAlert({ error }: ErrorAlertProps) {
  if (error === '') {
    return null;
  }

  return (
    <Alert className="mb-2" variant="danger">
      <div><strong>{error}</strong></div>
      <div>Please try again or contact support for help.</div>
    </Alert>
  );
}

type ErrorAlertProps = {
  error: string;
};
